import { makeAutoObservable } from "mobx";
import { TOAST_VARIANTS } from "./toast-message/toast-message";

export interface ActionButtonProps {
    title: string;
    onClick: () => void;
}

export interface IToast {
    title: string;
    description: React.ReactNode;
    variant?: TOAST_VARIANTS;
    actionButton?: ActionButtonProps;
    hasCloseButton?: boolean;
}

class ToastMessagesListStore {
    private _list: ToastMessageStore[] = [];

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    private remove(toast: ToastMessageStore): void {
        const index = this._list.findIndex((item) => item === toast);
        if (index === -1) {
            return;
        }
        this._list.splice(index, 1);
    }

    /** Returns the toast raised, so an action on it can take it down again. */
    public add(toast: IToast): ToastMessageStore {
        const item = new ToastMessageStore(toast, this.remove);
        this._list.unshift(item);
        console.log('ToastMessagesListStore: Added toast', toast, JSON.parse(JSON.stringify(this._list)));
        return item;
    }

    public get list(): ToastMessageStore[] {
        return this._list;
    }
}

export class ToastMessageStore {
    constructor(
        private _model: IToast,
        private _remove: (item: ToastMessageStore) => void
    ) {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public remove(): void {
        this._remove(this);
    }

    public get title(): string {
        return this._model.title;
    }

    public get description(): React.ReactNode {
        return this._model.description;
    }

    public get variant(): TOAST_VARIANTS {
        return this._model.variant ?? TOAST_VARIANTS.SUCCESS;
    }

    public get actionButton(): ActionButtonProps | undefined {
        return this._model.actionButton;
    }

    public get hasCloseButton(): boolean | undefined {
        return this._model.hasCloseButton ?? true;
    }
}

const toastMessageListStore = new ToastMessagesListStore();
export default toastMessageListStore;
